"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@dc/ui/components";
import { useTranslations } from "next-intl";
import { useContactSales } from "@/components/ContactSalesModal/hooks/useContactSales";
import type { ContactSalesOrigin } from "@/components/ContactSalesModal/types";
import type { TrialErrorCode } from "@/lib/trialError";
interface TrialErrorModalProps {
  errorCode: TrialErrorCode | null;
  onClose: () => void;
}
const i18nKeyMap: Record<TrialErrorCode, {
  title: string;
  body1: string;
  body2: string;
  origin: ContactSalesOrigin;
}> = {
  TRIAL_EXPIRED: {
    title: "trial_expired_title",
    body1: "trial_expired_body_1",
    body2: "trial_expired_body_2",
    origin: "trial_guard_expired"
  },
  TRIAL_PROJECT_LIMIT_REACHED: {
    title: "trial_project_limit_reached_title",
    body1: "trial_project_limit_reached_body_1",
    body2: "trial_project_limit_reached_body_2",
    origin: "trial_guard_project_limit"
  }
};
export function TrialErrorModal(t0) {
  const $ = _c(44);
  const {
    errorCode,
    onClose
  } = t0;
  const t = useTranslations("trials");
  const {
    open
  } = useContactSales();
  if (!errorCode) {
    return null;
  }
  const keys = i18nKeyMap[errorCode];
  let t1;
  if ($[0] !== keys.origin || $[1] !== onClose || $[2] !== open) {
    t1 = function handleContactSales() {
      onClose();
      open(keys.origin);
    };
    $[0] = keys.origin;
    $[1] = onClose;
    $[2] = open;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleContactSales = t1;
  let t2;
  if ($[4] !== onClose) {
    t2 = isOpen => !isOpen && onClose();
    $[4] = onClose;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== keys.title || $[7] !== t) {
    t3 = t(keys.title);
    $[6] = keys.title;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <ModalHeader>{t3}</ModalHeader>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== keys.body1 || $[12] !== t) {
    t5 = t(keys.body1);
    $[11] = keys.body1;
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <p>{t5}</p>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== keys.body2 || $[17] !== t) {
    t7 = t(keys.body2);
    $[16] = keys.body2;
    $[17] = t;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t7) {
    t8 = <p>{t7}</p>;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t6 || $[22] !== t8) {
    t9 = <ModalBody className="gap-4 text-default-700 text-sm">{t6}{t8}</ModalBody>;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t) {
    t10 = t("trial_guard_continue_browsing");
    $[24] = t;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== onClose || $[27] !== t10) {
    t11 = <Button variant="bordered" onPress={onClose}>{t10}</Button>;
    $[26] = onClose;
    $[27] = t10;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t) {
    t12 = t("trial_guard_contact_sales");
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== handleContactSales || $[32] !== t12) {
    t13 = <Button color="primary" onPress={handleContactSales}>{t12}</Button>;
    $[31] = handleContactSales;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t11 || $[35] !== t13) {
    t14 = <ModalFooter>{t11}{t13}</ModalFooter>;
    $[34] = t11;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t14 || $[38] !== t4 || $[39] !== t9) {
    t15 = <ModalContent>{t4}{t9}{t14}</ModalContent>;
    $[37] = t14;
    $[38] = t4;
    $[39] = t9;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t15 || $[42] !== t2) {
    t16 = <Modal isOpen={true} size="md" onOpenChange={t2} skipBack={true}>{t15}</Modal>;
    $[41] = t15;
    $[42] = t2;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  return t16;
}